import { type PictogramIconProps } from './types';

// office_02
export const Letter = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 113 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M101.3 81.81H12.5C11.67 81.81 11 81.14 11 80.31V32.51C11 32.33 11.03 32.16 11.09 31.99C11.15 31.82 11.24 31.67 11.35 31.53C11.48 31.37 11.65 31.25 11.82 31.16C12.01 31.07 12.22 31.01 12.44 31C12.47 31 12.49 31 12.52 31H101.28C101.28 31 101.34 31 101.37 31C101.58 31 101.78 31.06 101.96 31.15C102.14 31.24 102.31 31.37 102.45 31.53C102.57 31.67 102.66 31.83 102.72 32.01C102.77 32.17 102.8 32.34 102.8 32.5V80.31C102.8 81.14 102.13 81.81 101.3 81.81ZM14 78.81H99.8V35.52L57.43 67.62C56.89 68.03 56.14 68.03 55.61 67.62L14 35.55V78.81ZM16.9 34L56.52 64.53L96.84 34H16.9Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M100.38 81.5003L69.0701 57.2103L70.9101 54.8403L102.22 79.1303L100.38 81.5003ZM13.4201 81.5003L11.5701 79.1403L42.6301 54.8203L44.4801 57.1803L13.4201 81.4903V81.5003Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};
